import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  content: {
    flexGrow: 1,
  },
  list: {
    overflow: 'hidden',
    width: '100%',
    height: '100%',
  },
  listInner: {
    'overflow-y': 'scroll',
    height: '100%',
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  addButton: {
    position: 'fixed',
    bottom: 76,
    right: 20,
  },
}));

export default useStyles;
